import MintInfoIcon from '@/assets/icons/MintInfoIcon.svg?react';
import smartstoreMobile1 from '@/assets/images/connect-guide/smartstore-mobile-1.png';
import smartstoreMobile2 from '@/assets/images/connect-guide/smartstore-mobile-2.png';
import SmartstoreLoginGuideBottom from '@/assets/images/SmartstoreLoginGuideBottom.png';
import { Button } from '@/components/V3/Button';
import { useAppSelector } from '@/redux/store';
import { ROUTES } from '@/routes';
import { ChevronRightIcon, ExternalLinkIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { NumberBadge } from './number-badge';

export const SmartstoreGuidePage = () => {
  const user = useAppSelector((state) => state.user);

  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center  px-[105px] py-[120px] max-md:px-5 max-md:py-[60px] md:bg-gr-50">
      <div className="flex flex-col items-center gap-6">
        <div className="flex w-full flex-col  items-start space-y-2">
          <div className="text-gr-900 Title2S24">
            {user.StoreName}님의
            <br />
            셀러박스 구독이 완료됐어요!
          </div>
          <div className="text-gr-700 Body2M16">
            스마트 스토어의 리뷰 데이터 수집을 위해
            <br />
            셀러박스를 주매니저로 추가해 주세요
          </div>
        </div>
        <div className="border-gr-200 md:mt-5 md:rounded-lg md:border md:bg-white md:p-5">
          <div className="space-y-2 max-md:mt-6 md:space-y-5">
            <div className="text-gr-900 Title3S18 max-md:hidden">셀러박스 주매니저 등록하기</div>
            <div className="space-y-2.5">
              <div className="flex items-center gap-1 ">
                <MintInfoIcon />
                <div className="text-gr-900 Body3S15">셀러박스를 주매니저로 등록해 주세요!</div>
              </div>
              <div className="text-sm text-gr-900 md:hidden">
                셀러박스를 매니저로 등록하면
                <br />
                <span className="font-bold">리뷰 수집 및 답변 작성 기능</span>을 추가로 사용할 수
                있어요.
              </div>
              <div className="ml-7 text-sm text-gr-900 max-md:hidden">
                매니저 초대를 완료하지 않을 경우, 리뷰 수집 및 답글 작성 기능 사용이 제한돼요.
              </div>
            </div>
          </div>

          <Button
            variant="SolidLow"
            height="44"
            className="mt-4 flex items-center justify-center gap-1 Body3S15 md:hidden"
            onClick={() =>
              window.open('https://sell.smartstore.naver.com/#/member/auth/management')
            }
          >
            판매자 페이지 이동
            <ChevronRightIcon className="text-gr-400" />
          </Button>
          <Button
            variant="SolidLow"
            height="34"
            className="ml-7 mt-4 flex w-fit items-center justify-center gap-1 px-2.5 Body3S15 max-md:hidden"
            onClick={() =>
              window.open('https://sell.smartstore.naver.com/#/member/auth/management')
            }
          >
            판매자 페이지 이동
            <ExternalLinkIcon className="h-4 w-4 text-gr-700" />
          </Button>
          <img src={SmartstoreLoginGuideBottom} className="mt-6 w-[700px] max-md:hidden" />
          <div className="mt-6 space-y-10 md:hidden">
            <div className="space-y-4">
              <div className="flex items-center gap-1.5">
                <NumberBadge number={1} />
                <div className="text-gr-900">
                  <span className="font-bold">판매자 정보→매니저 관리</span> 클릭
                </div>
              </div>
              <img src={smartstoreMobile1} className="w-full" />
            </div>
            <div className="space-y-4">
              <div className="flex items-center gap-1.5">
                <NumberBadge number={2} />
                <div className="text-gr-900">
                  <span className="font-bold">매니저 초대</span> 버튼 클릭
                </div>
              </div>
              <img src={smartstoreMobile2} className="w-full" />
            </div>
            <div className="space-y-4">
              <div className="flex  gap-1.5">
                <NumberBadge number={3} />
                <div className="text-gr-900">
                  이름 : <span className="font-bold">셀러박스 입력</span>
                  <br />
                  번호 : <span className="font-bold">010-9348-3900 입력→추가</span>
                  <br />
                  매니저 : <span className="font-bold">계정 주매니저 선택</span>
                  <br />위 내용 선택 후, <span className="font-bold">확인</span> 버튼 클릭
                </div>
              </div>
              <img src={smartstoreMobile1} className="w-full" />
            </div>
          </div>
        </div>
        <Button className="w-[400px]" onClick={() => navigate(ROUTES.intro)}>
          확인했어요
        </Button>
      </div>
    </div>
  );
};
